import React from 'react';
import { Row, Col, Form, Collapse } from 'react-bootstrap';
import { Field } from 'formik';
import Select from 'react-select';
import MaskedInput from 'react-text-mask';
import {
  FaCalendarAlt,
  FaTag,
  FaSatelliteDish,
  FaHardHat,
} from 'react-icons/fa';
import { DropdownIndicator, customStyles } from '~/Styles/reactSelectStyles';
import { MASK_DATE } from '~/constant';
import {
  ACEITA_SMS_WHATS_OPTIONS,
  TIPO_VENDA_OPTIONS,
  DOCUMENTACAO_OPTIONS,
  LOTE_INTERESSE_OPTIONS,
  PERFIL_COMPRADOR_OPTIONS,
  TIPO_CAD_OPTIONS,
  LANCAMENTO_OPTIONS,
  TERRENO_CONSTRUCAO_OPTIONS,
  TIPO_RENDA_OPTIONS,
  ETAPA_TERRENO_CONSTRUCAO_OPTIONS,
  SENHA_OPTIONS,
  TAREFAS_OPTIONS,
} from './UtilsConvesaoLeads';

const selectProps = {
  styles: customStyles,
  components: { DropdownIndicator: DropdownIndicator },
};

const SectionCard = function(props) {
  return (
    <div className="cl-section">
      <div className="cl-section__header">
        <h6 className="cl-section__title">
          {props.icon && <span className="icon">{props.icon}</span>}
          {props.title}
        </h6>
        {props.headerRight}
      </div>
      <div className="cl-section__body">{props.children}</div>
    </div>
  );
};

const CampoData = function(props) {
  return (
    <Col md={props.colMd || 3}>
      <Form.Group>
        <small>{props.label}</small>
        <Field name={props.name}>
          {function(fieldProps) {
            return (
              <MaskedInput
                {...fieldProps.field}
                mask={MASK_DATE}
                className="form-control form-control-sm"
                placeholder="DD/MM/AAAA"
              />
            );
          }}
        </Field>
      </Form.Group>
    </Col>
  );
};

const CampoSelect = function(props) {
  return (
    <Col md={props.colMd || 3}>
      <Form.Group>
        <small>{props.label}</small>
        <Select
          placeholder={props.placeholder || 'Selecione...'}
          options={props.options}
          defaultValue={props.defaultValue}
          isClearable={props.isClearable !== false}
          isLoading={props.isLoading}
          isDisabled={props.isDisabled}
          onChange={function(selectedOption) {
            props.setFieldValue(
              props.name,
              selectedOption ? selectedOption.value : ''
            );
          }}
          {...selectProps}
        />
      </Form.Group>
    </Col>
  );
};

const FiltrosAvancados = function(props) {
  const aberto = props.filtrosAvancadosAberto;
  const setFieldValue = props.setFieldValue;
  const modoRecebimentoOpts = props.modoRecebimentoOpts;
  const canalOrigem = props.canalOrigem;
  const midiaOrigem = props.midiaOrigem;
  const valoresIniciaisFormulario = props.valoresIniciaisFormulario;
  const values = props.values || {};
  const empreendimentoSelecionado = !!(
    values.empreendimento && values.empreendimento !== '0'
  );
  React.useEffect(
    function() {
      if (!empreendimentoSelecionado && values.lancamento) {
        setFieldValue('lancamento', '');
      }
    },
    [empreendimentoSelecionado, values.lancamento, setFieldValue]
  );

  return (
    <Collapse in={aberto}>
      <div>
        <Row>
          <Col md={6}>
            <SectionCard title="Períodos" icon={<FaCalendarAlt />}>
              <Row>
                <CampoData
                  label="Vínculo - Início"
                  name="data_vinculo_inicio"
                />
                <CampoData label="Vínculo - Fim" name="data_vinculo_fim" />
                <CampoData
                  label="Cadastro - Início"
                  name="data_cadastro_inicio"
                />
                <CampoData label="Cadastro - Fim" name="data_cadastro_fim" />
                <CampoData
                  label="Conclusão Pasta - Início"
                  name="data_conclusao_pasta_inicio"
                />
                <CampoData
                  label="Conclusão Pasta - Fim"
                  name="data_conclusao_pasta_fim"
                />
                <CampoData
                  label="Nascimento - Início"
                  name="data_nascimento_inicio"
                />
                <CampoData
                  label="Nascimento - Fim"
                  name="data_nascimento_fim"
                />
              </Row>
            </SectionCard>
          </Col>

          <Col md={6}>
            <SectionCard title="Classificação" icon={<FaTag />}>
              <Row>
                <CampoSelect
                  label="Tipo de Venda"
                  name="tipo_venda"
                  placeholder="Com e Sem Venda"
                  options={TIPO_VENDA_OPTIONS}
                  defaultValue={TIPO_VENDA_OPTIONS[0]}
                  setFieldValue={setFieldValue}
                />
                <CampoSelect
                  label="Documentação"
                  name="documentacao"
                  placeholder="Todos"
                  options={DOCUMENTACAO_OPTIONS}
                  defaultValue={DOCUMENTACAO_OPTIONS[0]}
                  setFieldValue={setFieldValue}
                />
                <CampoSelect
                  label="Perfil Comprador"
                  name="perfil_comprador"
                  placeholder="Escolha..."
                  options={PERFIL_COMPRADOR_OPTIONS}
                  setFieldValue={setFieldValue}
                />
                <CampoSelect
                  label="Tipo de Cadastro"
                  name="tipo_cad"
                  placeholder="Todos"
                  options={TIPO_CAD_OPTIONS}
                  defaultValue={TIPO_CAD_OPTIONS[0]}
                  setFieldValue={setFieldValue}
                />
                <CampoSelect
                  label="Lote de Interesse"
                  name="lote_interesse"
                  placeholder="Escolha..."
                  options={LOTE_INTERESSE_OPTIONS}
                  setFieldValue={setFieldValue}
                />
                <CampoSelect
                  label="Lançamento"
                  name="lancamento"
                  placeholder={
                    empreendimentoSelecionado
                      ? 'Escolha...'
                      : 'Selecione um empreendimento'
                  }
                  options={LANCAMENTO_OPTIONS}
                  setFieldValue={setFieldValue}
                  isDisabled={!empreendimentoSelecionado}
                />
                <CampoSelect
                  label="Interesse Social"
                  name="interesse_social"
                  placeholder="Selecione..."
                  options={[
                    { value: true, label: 'Sim' },
                    { value: false, label: 'Não' },
                  ]}
                  setFieldValue={setFieldValue}
                />
                <CampoSelect
                  label="Senha"
                  name="senha"
                  placeholder="Selecione..."
                  options={SENHA_OPTIONS}
                  setFieldValue={setFieldValue}
                />
              </Row>
            </SectionCard>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <SectionCard
              title="Origem e Comunicação"
              icon={<FaSatelliteDish />}
            >
              <Row>
                <CampoSelect
                  label="Canal Origem"
                  name="canal_origem"
                  placeholder="Selecione..."
                  options={canalOrigem}
                  isLoading={canalOrigem.length === 0}
                  isDisabled={canalOrigem.length === 0}
                  defaultValue={canalOrigem.find(function(c) {
                    return c.value === valoresIniciaisFormulario.canal_origem;
                  })}
                  setFieldValue={setFieldValue}
                />
                <CampoSelect
                  label="Mídia Origem"
                  name="midia_origem"
                  placeholder="Selecione..."
                  options={midiaOrigem}
                  isLoading={midiaOrigem.length === 0}
                  isDisabled={midiaOrigem.length === 0}
                  defaultValue={midiaOrigem.find(function(m) {
                    return m.value === valoresIniciaisFormulario.midia_origem;
                  })}
                  setFieldValue={setFieldValue}
                />
                <CampoSelect
                  label="SMS/WhatsApp"
                  name="aceita_sms_whatsapp"
                  placeholder="Todos"
                  options={ACEITA_SMS_WHATS_OPTIONS}
                  defaultValue={ACEITA_SMS_WHATS_OPTIONS[0]}
                  setFieldValue={setFieldValue}
                />
                <CampoSelect
                  label="Modo Recebimento"
                  name="modo_recebimento"
                  placeholder="Todos"
                  options={modoRecebimentoOpts}
                  setFieldValue={setFieldValue}
                />
                <CampoSelect
                  label="Tarefas"
                  name="tarefas"
                  placeholder="Selecione..."
                  options={TAREFAS_OPTIONS}
                  setFieldValue={setFieldValue}
                />
              </Row>
            </SectionCard>
          </Col>

          <Col md={6}>
            <SectionCard title="Terreno e Construção" icon={<FaHardHat />}>
              <Row>
                <CampoSelect
                  colMd={6}
                  label="Terreno e Construção"
                  name="terreno_construcao_filtro"
                  placeholder="Ambos"
                  options={TERRENO_CONSTRUCAO_OPTIONS}
                  setFieldValue={setFieldValue}
                />
                <CampoSelect
                  colMd={6}
                  label="Etapa Terreno e Construção"
                  name="etapa_terreno_construcao_filtro"
                  placeholder="Todas"
                  options={ETAPA_TERRENO_CONSTRUCAO_OPTIONS}
                  setFieldValue={setFieldValue}
                />
              </Row>
            </SectionCard>
          </Col>
        </Row>
      </div>
    </Collapse>
  );
};

export default FiltrosAvancados;
